import SpriteSymbol from "../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "ZendeskTicketingColor.svg",
  "use": "ZendeskTicketingColor.svg-usage",
  "viewBox": "0 0 39 30",
  "content": "<symbol viewBox=\"0 0 39 30\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"ZendeskTicketingColor.svg\">\n<path d=\"M18.216 8.47582V30H0.440467L18.216 8.47582ZM18.216 0.75C18.216 5.67307 14.2368 9.66405 9.32822 9.66405C4.41963 9.66405 0.44043 5.67307 0.44043 0.75H18.216ZM21.1444 30C21.1444 25.0769 25.1236 21.086 30.0322 21.086C34.9408 21.086 38.92 25.0769 38.92 30H21.1444ZM21.1444 22.2741V0.75H38.9219L21.1444 22.2741Z\" fill=\"#00363D\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol